import { render, staticRenderFns } from "./TaskNewComment.vue?vue&type=template&id=732537ae"
import script from "./TaskNewComment.vue?vue&type=script&lang=js"
export * from "./TaskNewComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports